import React, { useEffect, useState, useRef, useCallback } from "react";
import { ProgressBar } from "react-bootstrap";
import { Button, Collapse } from "react-blueprint-library";
import LostDataModal from "../../SharedComponents/LostDataModal";
import { FORM_ID, FORM_NAMES } from "../../../constants/Forms";
import "./StartApplicationNav.scss";
import { UtagTracking } from "../../../utils/utag-tracking";
import { CONTRACT_TYPE_DESCRIPTIONS } from "../../../constants/Contract";
import StartAppNavItem from "./StartAppNavItem";
import {
  isCareerContract,
  isCriaOnlyContract,
} from "../../../common/Functions";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "react-redux";
import DocConfirmationModal from "../../LandingPages/HomePages/UploadDocument/DocConfirmationModal";
import UploadDocument from "../../LandingPages/HomePages/UploadDocument";
import {
  getCandidateDocumentStatuses,
  getCandidateReqDocumentStatuses,
} from "../../../api/FilenetDocuments";
import { uploadedReqDocsActions } from "../../../store/slice/uploadedDocs";

const personalInfoForms = [
  FORM_ID.PERSONAL_INFO,
  FORM_ID.PERSONAL_INFO_ADDITIONAL_INFO,
  FORM_ID.PERSONAL_INFO_COVER_ADVISOR,
];
const educationForms = [FORM_ID.EDUCATION, FORM_ID.PROFESSIONAL_DESIGNATION];
const ccbForms = [
  FORM_ID.CCB_INTRO,
  FORM_ID.CRIMINAL_DISCLOSURE,
  FORM_ID.REGULATORY_ACTION_DISCLOSURE,
  FORM_ID.CIVIL_JUDICIAL_DISCLOSURE,
  FORM_ID.CUSTOMER_COMPLAINT_DISCLOSURE,
  FORM_ID.TERMINATION_DISCLOSURE,
  FORM_ID.FINANCIAL_DISCLOSURE,
];
const empHistoryForms = [
  FORM_ID.EMPLOYMENT_HISTORY,
  FORM_ID.PERSONAL_SALES_RECORD,
  FORM_ID.PERSONAL_SALES_RECORD_CHARTS,
];
const corpForms = [
  FORM_ID.CORPORATE_INFO,
  FORM_ID.CORPORATE_BUSINESS_ADDRESS,
  FORM_ID.CORPORATE_CCB,
  FORM_ID.CORPORATE_ERRORS_OMISSIONS,
  FORM_ID.CORPORATE_DIRECT_DEPOSIT,
];
const memberOfCorpForms = [
  FORM_ID.RELEASE_OF_INFO,
  FORM_ID.AUTHORIZATION,
  FORM_ID.PERSONAL_INFO,
  FORM_ID.RESIDENTIAL_ADDRESS,
  FORM_ID.BUSINESS_INFO,
  FORM_ID.BROKER_DEALER,
  FORM_ID.CCB,
  FORM_ID.ERRORS_OMISSIONS,
];
const ReviewSignForms = [FORM_ID.REVIEW_SIGN_1, FORM_ID.REVIEW_SIGN_2];
const mmlisForms = [
  FORM_ID.MMLIS_INTRO,
  FORM_ID.MMLIS_PAY_TO_PLAY_1,
  FORM_ID.MMLIS_PAY_TO_PLAY_2,
  FORM_ID.MMLIS_OBA_CRIA,
];

const StartApplicationNav = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [refetchDocStatus, setRefetchDocStatus] = useState(false);
  const [docReqUploadModalData, setDocReqUploadModalData] = useState({
    oktaSubId: props?.oktasubid,
    contractid: props?.contractid,
    contracttypedesc: props?.contracttypedesc,
    isRequested: false,
  });
  const [disableReviewSignBtn, setDisableReviewSignBtn] = useState(true);
  const [progressNumber, setProgressNumber] = useState(0);
  const [empHistOpen, setEmpHistOpen] = useState(false);
  const [ccbOpen, setCCBOpen] = useState(false);
  const [corpOpen, setCorpOpen] = useState(false);
  const [mcOpen, setMCOpen] = useState(false);
  const prevProps = useRef(props);
  const northwestemploy = useSelector(
    (state) =>
      state.additionalInfoPageInitialState.additionalInfo.northwestemploy ===
      "Y",
  );

  const { showLogoutModal } = useSelector((state) => state.logoutModal);
  const dispatch = useDispatch();

  const employmentHistoryCollapseButton =
    document.getElementById("collapseEmp");
  const ccbCollapseButton = document.getElementById("collapseCCB");
  const brokerCorpCollapseButton = document.getElementById("collapseCorp");
  const memberCorpCollapseButton = document.getElementById("collapseMC");

  const handleExitClick = () => {
    window.location = "/";
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  const handleShowModal = () => {
    if (props?.currentFormChanged || showLogoutModal) {
      setShowModal(true);
    } else {
      handleExitClick();
    }
  };
  const handleShowUploadDocModal = () => {
    setShowUploadModal(true);
  };

  const handleCloseConfirmationModal = () => {
    setShowConfirmationModal(false);
  };
  const toggleDropdown = ({ target: { id, parentNode } }) => {
    if (id.includes("Corp") || (id === "" && parentNode?.id.includes("Corp"))) {
      setCorpOpen(!corpOpen);
    } else if (
      id.includes("MC") ||
      (id === "" && parentNode?.id.includes("MC"))
    ) {
      setMCOpen(!mcOpen);
    } else if (
      id.includes("Emp") ||
      (id === "" && parentNode?.id.includes("Emp"))
    ) {
      setEmpHistOpen(!empHistOpen);
    } else if (
      id.includes("CCB") ||
      (id === "" && parentNode?.id.includes("CCB"))
    ) {
      setCCBOpen(!ccbOpen);
    }
  };

  useEffect(() => {
    UtagTracking.sendPageNameView(
      "startapplicationnav",
      props.candidateId || "",
      props.agencynumber || "",
      props.contracttypeid || "",
    );
  }, []);

  useEffect(() => {
    const setProgress = () => {
      let trueCount = 0;
      let numberOfIndicators = 0;
      for (let item in props) {
        if (item.includes("Ind")) {
          numberOfIndicators += 1;
          if (props[item]) {
            if (item.includes("Disclosure")) {
              if (props[item].ind) {
                trueCount += 1;
              }
            } else {
              trueCount += 1;
            }
          }
        }
      }
      const progress = Math.round(
        100 - ((numberOfIndicators - trueCount) / numberOfIndicators) * 100,
      );

      setProgressNumber(progress);
      setDisableReviewSignBtn(!(progress === 100));
    };
    setProgress();
  }, [props]);

  useEffect(() => {
    if (
      empHistoryForms.includes(props?.currentForm) &&
      employmentHistoryCollapseButton &&
      !empHistOpen
    ) {
      setEmpHistOpen(true);
      employmentHistoryCollapseButton.click();
    } else if (
      empHistoryForms.includes(prevProps?.current?.currentForm) &&
      !empHistoryForms.includes(props?.currentForm) &&
      employmentHistoryCollapseButton &&
      empHistOpen
    ) {
      setEmpHistOpen(false);
      employmentHistoryCollapseButton.click();
    }

    if (
      ccbForms.includes(props?.currentForm) &&
      ccbCollapseButton &&
      !ccbOpen
    ) {
      setCCBOpen(true);
      ccbCollapseButton.click();
    } else if (
      ccbForms.includes(prevProps?.current?.currentForm) &&
      !ccbForms.includes(props?.currentForm) &&
      ccbCollapseButton &&
      ccbOpen
    ) {
      setCCBOpen(false);
      ccbCollapseButton.click();
    }

    if (
      corpForms.includes(props?.currentForm) &&
      brokerCorpCollapseButton &&
      !corpOpen
    ) {
      setCorpOpen(true);
      brokerCorpCollapseButton.click();
    } else if (
      corpForms.includes(prevProps?.current?.currentForm) &&
      !corpForms.includes(props?.currentForm) &&
      brokerCorpCollapseButton &&
      corpOpen
    ) {
      setCorpOpen(false);
      brokerCorpCollapseButton.click();
    }

    if (
      memberOfCorpForms.includes(props?.currentForm) &&
      memberCorpCollapseButton &&
      !mcOpen
    ) {
      setMCOpen(false);
      memberCorpCollapseButton.click();
    } else if (
      memberOfCorpForms.includes(prevProps?.current?.currentForm) &&
      !memberOfCorpForms.includes(props?.currentForm) &&
      memberCorpCollapseButton &&
      mcOpen
    ) {
      setMCOpen(false);
      memberCorpCollapseButton.click();
    }
    prevProps.current = props;
  }, [
    empHistOpen,
    ccbOpen,
    corpOpen,
    mcOpen,
    employmentHistoryCollapseButton,
    ccbCollapseButton,
    brokerCorpCollapseButton,
    memberCorpCollapseButton,
    props,
    prevProps,
  ]);

  const personalInfoPageStep =
    isCareerContract(props?.contracttypedesc) ||
    props?.contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.MMLIS
      ? props.currentForm === FORM_ID.PERSONAL_INFO
        ? "1/2"
        : props.currentForm === FORM_ID.PERSONAL_INFO_ADDITIONAL_INFO &&
            !northwestemploy
          ? "2/2"
          : props.currentForm === FORM_ID.PERSONAL_INFO_ADDITIONAL_INFO &&
              northwestemploy
            ? "2/3"
            : props.currentForm === FORM_ID.PERSONAL_INFO_COVER_ADVISOR &&
                northwestemploy
              ? "3/3"
              : "0/2"
      : "0/1";

  const educationPageStep = educationForms.includes(props.currentForm)
    ? props.currentForm === FORM_ID.EDUCATION
      ? "1/2"
      : "2/2"
    : "";

  const isEducationComplete =
    props.eduInfoCompleteInd && props.profDesInfoCompleteInd;

  const mmlisPageStep =
    props.currentForm === FORM_ID.MMLIS_PAY_TO_PLAY_1
      ? "1/3"
      : props.currentForm === FORM_ID.MMLIS_PAY_TO_PLAY_2
        ? "2/3"
        : props.currentForm === FORM_ID.MMLIS_OBA_CRIA
          ? "3/3"
          : "0/3";

  const reviewSignStep =
    props.currentForm === FORM_ID.REVIEW_SIGN_1
      ? "1/2"
      : props.currentForm === FORM_ID.REVIEW_SIGN_2
        ? "2/2"
        : "0/2";

  const getMobileFormKeyName = (formId) =>
    FORM_NAMES[Object.keys(FORM_ID).find((key) => FORM_ID[key] === formId)];

  const getMobilePageStep = (formId) => {
    let step = "0/1";
    if (ReviewSignForms.includes(formId)) {
      step = reviewSignStep;
    } else if (mmlisForms.includes(formId)) {
      step = mmlisPageStep;
    } else if (
      personalInfoForms.includes(formId) &&
      isCareerContract(props?.contracttypedesc)
    ) {
      step = personalInfoPageStep;
    } else if (educationForms.includes(formId)) {
      step = educationPageStep;
    } else if (
      formId === FORM_ID.CCB_INTRO ||
      formId === FORM_ID.CRIMINAL_DISCLOSURE
    ) {
      step = props?.crimDisclosureCompleteInd?.step;
    } else if (formId === FORM_ID.REGULATORY_ACTION_DISCLOSURE) {
      step = props?.regActionDisclosureCompleteInd?.step;
    } else if (formId === FORM_ID.CIVIL_JUDICIAL_DISCLOSURE) {
      step = props?.civilJudDisclosureCompleteInd?.step;
    } else if (formId === FORM_ID.CUSTOMER_COMPLAINT_DISCLOSURE) {
      step = props?.custCompDisclosureCompleteInd?.step;
    } else if (formId === FORM_ID.TERMINATION_DISCLOSURE) {
      step = props?.termDisclosureCompleteInd?.step;
    } else if (formId === FORM_ID.FINANCIAL_DISCLOSURE) {
      step = props?.finDisclosureCompleteInd?.step;
    }
    return step;
  };
  const getMobileFormCompleteInd = (formId) => {
    let isComplete = false;
    if (
      formId === FORM_ID.CORPORATE_INFO ||
      formId === FORM_ID.MEMBER_CORPORATE_INFO
    ) {
      isComplete = props.corpInfoCompleteInd;
    } else if (formId === FORM_ID.CORPORATE_BUSINESS_ADDRESS) {
      isComplete = props.corpbusAddrCompleteInd;
    } else if (formId === FORM_ID.CORPORATE_CCB) {
      isComplete = props.corpCCBCompleteInd;
    } else if (formId === FORM_ID.CORPORATE_ERRORS_OMISSIONS) {
      isComplete = props.corpEOCompleteInd;
    } else if (formId === FORM_ID.CORPORATE_DIRECT_DEPOSIT) {
      isComplete = props.corpDirectDepositCompleteInd;
    } else if (formId === FORM_ID.RELEASE_OF_INFO) {
      isComplete = props.rInfoCompleteInd;
    } else if (formId === FORM_ID.AUTHORIZATION) {
      isComplete = props.authorizationCompleteInd;
    } else if (formId === FORM_ID.PERSONAL_INFO) {
      isComplete = isCareerContract(props?.contracttypedesc)
        ? props.pInfoCompleteInd && props.pAddlInfoCompleteInd
        : props.pInfoCompleteInd;
    } else if (formId === FORM_ID.PERSONAL_INFO_ADDITIONAL_INFO) {
      isComplete = props.pAddlInfoCompleteInd;
    } else if (formId === FORM_ID.RESIDENTIAL_ADDRESS) {
      isComplete = props.resAddrCompleteInd;
    } else if (formId === FORM_ID.RESIDENTIAL_HISTORY) {
      isComplete = props.resHistoryCompleteInd;
    } else if (formId === FORM_ID.BUSINESS_INFO) {
      isComplete = props.busAddrCompleteInd;
    } else if (formId === FORM_ID.EDUCATION) {
      isComplete = props.eduInfoCompleteInd && props.profDesInfoCompleteInd;
    } else if (formId === FORM_ID.PROFESSIONAL_DESIGNATION) {
      isComplete = props.profDesInfoCompleteInd;
    } else if (formId === FORM_ID.EMPLOYMENT_HISTORY) {
      isComplete = props.empHistCompleteInd;
    } else if (
      formId === FORM_ID.PERSONAL_SALES_RECORD ||
      formId === FORM_ID.PERSONAL_SALES_RECORD_CHARTS
    ) {
      isComplete = props.psrCompleteInd;
    } else if (formId === FORM_ID.BROKER_DEALER) {
      isComplete = props.brokerCompleteInd;
    } else if (formId === FORM_ID.CCB) {
      isComplete = props.ccbCompleteInd;
    } else if (formId === FORM_ID.ERRORS_OMISSIONS) {
      isComplete = props.EOCompleteInd;
    } else if (
      formId === FORM_ID.CCB_INTRO ||
      formId === FORM_ID.CRIMINAL_DISCLOSURE
    ) {
      isComplete = props?.crimDisclosureCompleteInd?.ind;
    } else if (formId === FORM_ID.REGULATORY_ACTION_DISCLOSURE) {
      isComplete = props?.regActionDisclosureCompleteInd?.ind;
    } else if (formId === FORM_ID.CIVIL_JUDICIAL_DISCLOSURE) {
      isComplete = props?.civilJudDisclosureCompleteInd?.ind;
    } else if (formId === FORM_ID.CUSTOMER_COMPLAINT_DISCLOSURE) {
      isComplete = props?.custCompDisclosureCompleteInd?.ind;
    } else if (formId === FORM_ID.TERMINATION_DISCLOSURE) {
      isComplete = props?.termDisclosureCompleteInd?.ind;
    } else if (formId === FORM_ID.FINANCIAL_DISCLOSURE) {
      isComplete = props?.finDisclosureCompleteInd?.ind;
    } else if (mmlisForms.includes(formId)) {
      isComplete =
        props.mmlisPage1CompleteInd &&
        props.mmlisPage2CompleteInd &&
        props.mmlisOBACRIACompleteInd;
    }
    return isComplete;
  };

  // Helper to get education nav step and completion
  const getEducationStepAndComplete = (
    currentForm,
    eduInfoCompleteInd,
    profDesInfoCompleteInd,
    currentFormChanged,
  ) => {
    if (
      currentForm === FORM_ID.PROFESSIONAL_DESIGNATION &&
      currentFormChanged
    ) {
      return { currentStep: "2/2", isPageComplete: false };
    }
    if (currentForm === FORM_ID.EDUCATION && currentFormChanged) {
      return { currentStep: "1/2", isPageComplete: false };
    }
    if (eduInfoCompleteInd && profDesInfoCompleteInd) {
      return { currentStep: "", isPageComplete: true };
    }
    if (currentForm === FORM_ID.EDUCATION) {
      return { currentStep: "1/2", isPageComplete: false };
    }

    if (currentForm === FORM_ID.PROFESSIONAL_DESIGNATION) {
      return { currentStep: "2/2", isPageComplete: false };
    }

    return { currentStep: "0/2", isPageComplete: false };
  };

  const getCriaEducationStepAndComplete = (
    currentForm,
    eduInfoCompleteInd,
    currentFormChanged,
  ) => {
    if (currentForm === FORM_ID.EDUCATION && currentFormChanged) {
      return { currentStep: "0/1", isPageComplete: false };
    }
    if (eduInfoCompleteInd) {
      return { currentStep: "", isPageComplete: true };
    }
    if (currentForm === FORM_ID.EDUCATION) {
      return { currentStep: "0/1", isPageComplete: false };
    }

    return { currentStep: "0/1", isPageComplete: false };
  };

  // Helper to get CRIA professional designation nav step and completion
  const getCriaProfDesStepAndComplete = (
    profDesCriaFormChanged,
    profRegCriaData,
    ProfRegCriaCompleteInd,
    userVisitedProfCriaPage,
  ) => {
    // If the form is dirty, show incomplete (1/1)
    if (profDesCriaFormChanged) {
      return { currentStep: "0/1", isPageComplete: false };
    }
    // If the form is not dirty but complete, show green checkmark
    if (ProfRegCriaCompleteInd) {
      return { currentStep: "", isPageComplete: true };
    }
    // If profDesInfoCompleteInd is true, always show complete
    // if (props.profDesInfoCompleteInd === true) {
    //   return { currentStep: '', isPageComplete: true };
    // }
    // If complete or visited, show complete
    let data = profRegCriaData;
    if (Array.isArray(data)) {
      data =
        data.find(
          (obj) =>
            obj.contractid === props.contractid &&
            obj.candidateid === props.candidateId,
        ) || {};
    }
    if (
      ProfRegCriaCompleteInd === true ||
      userVisitedProfCriaPage === true ||
      (Array.isArray(data.registrations) && data.registrations.length > 0) ||
      (Array.isArray(data.designations) && data.designations.length > 0) ||
      (Array.isArray(data.other_designations) &&
        data.other_designations.length > 0) ||
      (Array.isArray(data.otherDesignations) &&
        data.otherDesignations.length > 0)
    ) {
      return { currentStep: "", isPageComplete: true };
    }
    // Default
    return { currentStep: "0/1", isPageComplete: false };
  };

  useEffect(() => {
    if (educationForms.includes(props.currentForm)) {
      getEducationStepAndComplete(
        props.currentForm,
        props.eduInfoCompleteInd,
        props.profDesInfoCompleteInd,
        props.currentFormChanged,
      );
    }
  }, [
    props.contracttypedesc,
    props.eduInfoCompleteInd,
    props.profDesInfoCompleteInd,
    isEducationComplete,
    props.currentForm,
    props.currentFormChanged,
    props.eduInformation,
    props.ProfessionalDesignationsData,
  ]);

  useEffect(() => {
    const visited = localStorage.getItem("userVisitedProfCriaPage") === "true";
    if (visited && !props.userVisitedProfCriaPage) {
      if (props.setUserVisitedProfCriaPage) {
        props.setUserVisitedProfCriaPage(true);
      }
    }
  }, [props.setUserVisitedProfCriaPage, props.userVisitedProfCriaPage]);

  useEffect(() => {
    localStorage.setItem(
      "userVisitedProfCriaPage",
      props.userVisitedProfCriaPage ? "true" : "false",
    );
  }, [props.userVisitedProfCriaPage]);

  const fetchCandidateDocStatuses = useCallback(async () => {
    try {
      const reqStatuses = await getCandidateReqDocumentStatuses(
        props?.oktasubid,
      );

      if (reqStatuses?.results) {
        dispatch(uploadedReqDocsActions.setRequestedDocs(reqStatuses.results));
      } else {
        dispatch(uploadedReqDocsActions.resetReqDocs());
      }

      const statuses = await getCandidateDocumentStatuses(props?.oktasubid);

      if (statuses?.results) {
        dispatch(uploadedReqDocsActions.setUploadedDocs(statuses.results));
      } else {
        dispatch(uploadedReqDocsActions.resetUploadedDocs());
      }
    } catch (err) {
      console.error("Failed to fetch candidate req. document statuses:", err);
    }
    setRefetchDocStatus(false);
  }, [props?.oktasubid, dispatch]);

  useEffect(() => {
    if (refetchDocStatus) {
      fetchCandidateDocStatuses();
    }
  }, [refetchDocStatus, fetchCandidateDocStatuses]);

  const reqDocs = useSelector((state) => state.uploadedReqDocs.reqdocs);

  return (
    <div id="startAppNav">
      <div className="progress-bar-section">
        <div className="row">
          <div className="col-12">
            <h3 id="startAppNavProgressHeader">Application Progress</h3>
          </div>
        </div>
        <div className="row">
          <div
            id="startAppNavProgressBar"
            aria-label="Progress Bar Div NavBroker"
            className="col-7"
          >
            <ProgressBar
              id="progressBar"
              now={parseInt(progressNumber)}
              aria-label="Progress Bar NavBroker"
            />
          </div>
          <div id="startAppNavProgressBarLabel" className="col-5">
            <strong>
              <span id="progressComplete">{progressNumber}% Complete</span>
            </strong>
          </div>
        </div>
      </div>
      {!props?.isLoading && (
        <>
          <div className="mobile-nav-item">
            <StartAppNavItem
              pageNumber={props.currentForm}
              isCurrentPage={true}
              isPageComplete={getMobileFormCompleteInd(props.currentForm)}
              navName={
                props?.hasNYRegs
                  ? getMobileFormKeyName(props.currentForm).replace(
                      "Sales",
                      "Production",
                    )
                  : getMobileFormKeyName(props.currentForm)
              }
              currentStep={getMobilePageStep(props.currentForm)}
            ></StartAppNavItem>
          </div>
          <div className="nav-items">
            {props?.contracttypedesc ===
              CONTRACT_TYPE_DESCRIPTIONS.BROKER_CORP && (
              <Collapse id="corpAccordion">
                <Collapse.Group>
                  <Collapse.Toggle
                    id="collapseCorp"
                    eventKey="corp1"
                    onClick={(event) => toggleDropdown(event)}
                  >
                    <h3 id="sidebarCorp">Corporation</h3>
                  </Collapse.Toggle>
                  <Collapse.Collapse eventKey="corp1">
                    <StartAppNavItem
                      pageNumber={FORM_ID.CORPORATE_INFO}
                      isCurrentPage={
                        props.currentForm === FORM_ID.CORPORATE_INFO
                      }
                      isPageComplete={props.corpInfoCompleteInd}
                      navName={FORM_NAMES.CORPORATE_INFO}
                    ></StartAppNavItem>
                    <StartAppNavItem
                      pageNumber={FORM_ID.CORPORATE_BUSINESS_ADDRESS}
                      isCurrentPage={
                        props.currentForm === FORM_ID.CORPORATE_BUSINESS_ADDRESS
                      }
                      isPageComplete={props.corpbusAddrCompleteInd}
                      navName={FORM_NAMES.BUSINESS_INFO}
                    ></StartAppNavItem>
                    <StartAppNavItem
                      pageNumber={FORM_ID.CORPORATE_CCB}
                      isCurrentPage={
                        props.currentForm === FORM_ID.CORPORATE_CCB
                      }
                      isPageComplete={props.corpCCBCompleteInd}
                      navName={FORM_NAMES.CORPORATE_CCB}
                    ></StartAppNavItem>
                    <StartAppNavItem
                      pageNumber={FORM_ID.CORPORATE_ERRORS_OMISSIONS}
                      isCurrentPage={
                        props.currentForm === FORM_ID.CORPORATE_ERRORS_OMISSIONS
                      }
                      isPageComplete={props.corpEOCompleteInd}
                      navName={FORM_NAMES.CORPORATE_ERRORS_OMISSIONS}
                    ></StartAppNavItem>
                    <StartAppNavItem
                      pageNumber={FORM_ID.CORPORATE_DIRECT_DEPOSIT}
                      isCurrentPage={
                        props.currentForm === FORM_ID.CORPORATE_DIRECT_DEPOSIT
                      }
                      isPageComplete={props.corpDirectDepositCompleteInd}
                      navName={FORM_NAMES.DIRECT_DEPOSIT}
                    ></StartAppNavItem>
                  </Collapse.Collapse>
                </Collapse.Group>
              </Collapse>
            )}
            <Collapse id="mcAccordion">
              <Collapse.Group>
                {props.contracttypedesc ===
                  CONTRACT_TYPE_DESCRIPTIONS.BROKER_CORP && (
                  <Collapse.Toggle
                    id="collapseMC"
                    eventKey="member1"
                    onClick={(event) => toggleDropdown(event)}
                  >
                    <h3 id="sidebarMC">Member of Corporation</h3>
                  </Collapse.Toggle>
                )}

                <Collapse.Collapse
                  eventKey="member1"
                  className={
                    props.contracttypedesc !==
                    CONTRACT_TYPE_DESCRIPTIONS.BROKER_CORP
                      ? "show"
                      : "hide"
                  }
                >
                  {props.contracttypedesc !==
                    CONTRACT_TYPE_DESCRIPTIONS.FINANCING_ONLY &&
                    props.contracttypedesc !==
                      CONTRACT_TYPE_DESCRIPTIONS.AGENT_EMERITUS &&
                    props.contracttypedesc !==
                      CONTRACT_TYPE_DESCRIPTIONS.RETIRED_BROKER &&
                    props.contracttypedesc !==
                      CONTRACT_TYPE_DESCRIPTIONS.CRIA_ONLY &&
                    props.contracttypedesc !==
                      CONTRACT_TYPE_DESCRIPTIONS.INVESTMENT_ADVISOR && (
                      <StartAppNavItem
                        pageNumber={FORM_ID.RELEASE_OF_INFO}
                        isCurrentPage={
                          props.currentForm === FORM_ID.RELEASE_OF_INFO
                        }
                        isPageComplete={props.rInfoCompleteInd}
                        navName={FORM_NAMES.RELEASE_OF_INFO}
                      ></StartAppNavItem>
                    )}
                  {props.contracttypedesc !==
                    CONTRACT_TYPE_DESCRIPTIONS.FINANCING_ONLY &&
                    props.contracttypedesc !==
                      CONTRACT_TYPE_DESCRIPTIONS.AGENT_EMERITUS &&
                    props.contracttypedesc !==
                      CONTRACT_TYPE_DESCRIPTIONS.RETIRED_BROKER &&
                    props.contracttypedesc !==
                      CONTRACT_TYPE_DESCRIPTIONS.CRIA_ONLY &&
                    props.contracttypedesc !==
                      CONTRACT_TYPE_DESCRIPTIONS.INVESTMENT_ADVISOR && (
                      <StartAppNavItem
                        pageNumber={FORM_ID.AUTHORIZATION}
                        isCurrentPage={
                          props.currentForm === FORM_ID.AUTHORIZATION
                        }
                        isPageComplete={props.authorizationCompleteInd}
                        navName={FORM_NAMES.AUTHORIZATION}
                      ></StartAppNavItem>
                    )}
                  {props.contracttypedesc ===
                    CONTRACT_TYPE_DESCRIPTIONS.MEMBER_CORP && (
                    <StartAppNavItem
                      pageNumber={FORM_ID.MEMBER_CORPORATE_INFO}
                      isCurrentPage={
                        props.currentForm === FORM_ID.MEMBER_CORPORATE_INFO
                      }
                      isPageComplete={props.corpInfoCompleteInd}
                      navName={FORM_NAMES.MEMBER_CORPORATE_INFO}
                    ></StartAppNavItem>
                  )}
                  <StartAppNavItem
                    pageNumber={FORM_ID.PERSONAL_INFO}
                    isCurrentPage={
                      props.currentForm === FORM_ID.PERSONAL_INFO ||
                      props.currentForm ===
                        FORM_ID.PERSONAL_INFO_ADDITIONAL_INFO ||
                      props.currentForm === FORM_ID.PERSONAL_INFO_COVER_ADVISOR
                    }
                    isPageComplete={(() => {
                      const desc = props?.contracttypedesc;
                      if (
                        desc === CONTRACT_TYPE_DESCRIPTIONS.PRELIMINARY ||
                        desc === CONTRACT_TYPE_DESCRIPTIONS.MMLIS
                      ) {
                        return (
                          props.pInfoCompleteInd && props.pAddlInfoCompleteInd
                        );
                      }
                      if (
                        isCareerContract(desc) &&
                        desc !== CONTRACT_TYPE_DESCRIPTIONS.PRELIMINARY &&
                        northwestemploy
                      ) {
                        return (
                          props.pInfoCompleteInd &&
                          props.coveredAdvisorCertificateCompleteInd
                        );
                      }
                      if (
                        isCareerContract(desc) &&
                        desc !== CONTRACT_TYPE_DESCRIPTIONS.PRELIMINARY &&
                        !northwestemploy
                      ) {
                        return (
                          props.pInfoCompleteInd && props.pAddlInfoCompleteInd
                        );
                      }
                      return props.pInfoCompleteInd;
                    })()}
                    navName={FORM_NAMES.PERSONAL_INFO}
                    currentStep={personalInfoPageStep}
                  ></StartAppNavItem>
                  {(props.contracttypedesc ===
                    CONTRACT_TYPE_DESCRIPTIONS.MEMBER_CORP ||
                    props.contracttypedesc ===
                      CONTRACT_TYPE_DESCRIPTIONS.BROKER_CORP ||
                    props.contracttypedesc ===
                      CONTRACT_TYPE_DESCRIPTIONS.INDIVIDUAL_BROKER ||
                    props.contracttypedesc ===
                      CONTRACT_TYPE_DESCRIPTIONS.AGENT_EMERITUS ||
                    props.contracttypedesc ===
                      CONTRACT_TYPE_DESCRIPTIONS.RETIRED_BROKER) && (
                    <StartAppNavItem
                      pageNumber={FORM_ID.RESIDENTIAL_ADDRESS}
                      isCurrentPage={
                        props.currentForm === FORM_ID.RESIDENTIAL_ADDRESS
                      }
                      isPageComplete={props.resAddrCompleteInd}
                      navName={FORM_NAMES.RESIDENTIAL_ADDRESS}
                    ></StartAppNavItem>
                  )}
                  {(isCareerContract(props.contracttypedesc) ||
                    props.contracttypedesc ===
                      CONTRACT_TYPE_DESCRIPTIONS.MMLIS) && (
                    <StartAppNavItem
                      pageNumber={FORM_ID.RESIDENTIAL_HISTORY}
                      isCurrentPage={
                        props.currentForm === FORM_ID.RESIDENTIAL_HISTORY
                      }
                      isPageComplete={props.resHistoryCompleteInd}
                      navName={FORM_NAMES.RESIDENTIAL_HISTORY}
                    ></StartAppNavItem>
                  )}
                  {props.contracttypedesc !==
                    CONTRACT_TYPE_DESCRIPTIONS.COLLEGE_INTERN &&
                    props.contracttypedesc !==
                      CONTRACT_TYPE_DESCRIPTIONS.FINANCING_ONLY &&
                    props.contracttypedesc !==
                      CONTRACT_TYPE_DESCRIPTIONS.CRIA_ONLY &&
                    props.contracttypedesc !==
                      CONTRACT_TYPE_DESCRIPTIONS.INVESTMENT_ADVISOR && (
                      <StartAppNavItem
                        pageNumber={FORM_ID.BUSINESS_INFO}
                        isCurrentPage={
                          props.currentForm === FORM_ID.BUSINESS_INFO
                        }
                        isPageComplete={props.busAddrCompleteInd}
                        navName={FORM_NAMES.BUSINESS_INFO}
                      ></StartAppNavItem>
                    )}
                  {(isCareerContract(props.contracttypedesc) ||
                    props.isCria ||
                    props.isIA) &&
                    (() => {
                      const { currentStep, isPageComplete } =
                        getEducationStepAndComplete(
                          props.currentForm,
                          props.eduInfoCompleteInd,
                          props.profDesInfoCompleteInd,
                          props.currentFormChanged,
                        );
                      return (
                        <StartAppNavItem
                          pageNumber={FORM_ID.EDUCATION}
                          isCurrentPage={
                            props.currentForm === FORM_ID.EDUCATION ||
                            props.currentForm ===
                              FORM_ID.PROFESSIONAL_DESIGNATION
                          }
                          isPageComplete={isPageComplete}
                          navName={FORM_NAMES.EDUCATION}
                          currentStep={currentStep}
                        />
                      );
                    })()}
                  {isCriaOnlyContract(props.contracttypedesc) &&
                    (() => {
                      const { currentStep, isPageComplete } =
                        getCriaEducationStepAndComplete(
                          props.currentForm,
                          props.eduInfoCompleteInd,
                          props.currentFormChanged,
                        );
                      return (
                        <StartAppNavItem
                          pageNumber={FORM_ID.EDUCATION}
                          isCurrentPage={
                            props.currentForm === FORM_ID.EDUCATION
                          }
                          isPageComplete={isPageComplete}
                          navName={FORM_NAMES.EDUCATION}
                          currentStep={currentStep}
                        />
                      );
                    })()}
                  {(isCriaOnlyContract(props.contracttypedesc) ||
                    props.isCria === true ||
                    props.isIA === true) &&
                    (() => {
                      const profRegCriaData =
                        props.profRegCriaData ||
                        props.profDesCriaData ||
                        props.ProfessionalDesignationsCriaData ||
                        [];
                      const { currentStep, isPageComplete } =
                        getCriaProfDesStepAndComplete(
                          props.profDesCriaFormChanged,
                          profRegCriaData,
                          props.ProfRegCriaCompleteInd,
                          props.userVisitedProfCriaPage,
                        );
                      return (
                        <StartAppNavItem
                          pageNumber={FORM_ID.PROFESSIONAL_DESIGNATION_CRIA}
                          isCurrentPage={
                            props.currentForm ===
                            FORM_ID.PROFESSIONAL_DESIGNATION_CRIA
                          }
                          isPageComplete={isPageComplete}
                          navName={FORM_NAMES.PROFESSIONAL_DESIGNATION_CRIA}
                          currentStep={currentStep}
                        />
                      );
                    })()}
                  {props.contracttypedesc !==
                    CONTRACT_TYPE_DESCRIPTIONS.BROKER_CORP &&
                    props.contracttypedesc !==
                      CONTRACT_TYPE_DESCRIPTIONS.MEMBER_CORP &&
                    props.contracttypedesc !==
                      CONTRACT_TYPE_DESCRIPTIONS.INDIVIDUAL_BROKER &&
                    props.contracttypedesc !==
                      CONTRACT_TYPE_DESCRIPTIONS.FINANCING_ONLY &&
                    props.contracttypedesc !==
                      CONTRACT_TYPE_DESCRIPTIONS.RETIRED_BROKER &&
                    props.contracttypedesc !==
                      CONTRACT_TYPE_DESCRIPTIONS.AGENT_EMERITUS &&
                    props.contracttypedesc !==
                      CONTRACT_TYPE_DESCRIPTIONS.CRIA_ONLY &&
                    props.contracttypedesc !==
                      CONTRACT_TYPE_DESCRIPTIONS.INVESTMENT_ADVISOR && (
                      <>
                        <Collapse id="employmentHistoryAccordion">
                          <Collapse.Group>
                            <Collapse.Toggle
                              id="collapseEmp"
                              eventKey="emp1"
                              onClick={(event) => toggleDropdown(event)}
                            >
                              <h3 id="sidebarEmp">
                                {FORM_NAMES.EMPLOYMENT_HISTORY}
                              </h3>
                            </Collapse.Toggle>
                            <Collapse.Collapse eventKey="emp1">
                              <StartAppNavItem
                                pageNumber={FORM_ID.EMPLOYMENT_HISTORY}
                                isCurrentPage={
                                  props.currentForm ===
                                  FORM_ID.EMPLOYMENT_HISTORY
                                }
                                isPageComplete={props.empHistCompleteInd}
                                navName={FORM_NAMES.EMPLOYMENT_HISTORY}
                              ></StartAppNavItem>
                              {props.psrData > 0 &&
                              props.contracttypedesc !==
                                CONTRACT_TYPE_DESCRIPTIONS.MMLIS ? (
                                <StartAppNavItem
                                  pageNumber={FORM_ID.PERSONAL_SALES_RECORD}
                                  isCurrentPage={
                                    props.currentForm ===
                                      FORM_ID.PERSONAL_SALES_RECORD ||
                                    props.currentForm ===
                                      FORM_ID.PERSONAL_SALES_RECORD_CHARTS
                                  }
                                  isPageComplete={props.psrCompleteInd}
                                  navName={
                                    props?.hasNYRegs
                                      ? FORM_NAMES.PERSONAL_PRODUCTION_RECORD
                                      : FORM_NAMES.PERSONAL_SALES_RECORD
                                  }
                                ></StartAppNavItem>
                              ) : (
                                <hr />
                              )}
                            </Collapse.Collapse>
                          </Collapse.Group>
                        </Collapse>
                        <Collapse id="ccbAccordion">
                          <Collapse.Group>
                            <Collapse.Toggle
                              id="collapseCCB"
                              eventKey="ccb1"
                              onClick={(event) => toggleDropdown(event)}
                            >
                              <h3 id="sidebarCCB">{FORM_NAMES.CCB}</h3>
                            </Collapse.Toggle>
                            <Collapse.Collapse eventKey="ccb1">
                              <StartAppNavItem
                                pageNumber={FORM_ID.CRIMINAL_DISCLOSURE}
                                isCurrentPage={
                                  props.currentForm ===
                                    FORM_ID.CRIMINAL_DISCLOSURE ||
                                  props.currentForm === FORM_ID.CCB_INTRO
                                }
                                isPageComplete={
                                  props?.crimDisclosureCompleteInd?.ind
                                }
                                navName={FORM_NAMES.CRIMINAL_DISCLOSURE}
                                currentStep={
                                  props?.crimDisclosureCompleteInd?.step
                                }
                              ></StartAppNavItem>
                              <StartAppNavItem
                                pageNumber={
                                  FORM_ID.REGULATORY_ACTION_DISCLOSURE
                                }
                                isCurrentPage={
                                  props.currentForm ===
                                  FORM_ID.REGULATORY_ACTION_DISCLOSURE
                                }
                                isPageComplete={
                                  props?.regActionDisclosureCompleteInd?.ind
                                }
                                navName={
                                  FORM_NAMES.REGULATORY_ACTION_DISCLOSURE
                                }
                                currentStep={
                                  props?.regActionDisclosureCompleteInd?.step
                                }
                              ></StartAppNavItem>
                              <StartAppNavItem
                                pageNumber={FORM_ID.CIVIL_JUDICIAL_DISCLOSURE}
                                isCurrentPage={
                                  props.currentForm ===
                                  FORM_ID.CIVIL_JUDICIAL_DISCLOSURE
                                }
                                isPageComplete={
                                  props?.civilJudDisclosureCompleteInd?.ind
                                }
                                navName={FORM_NAMES.CIVIL_JUDICIAL_DISCLOSURE}
                                currentStep={
                                  props?.civilJudDisclosureCompleteInd?.step
                                }
                              ></StartAppNavItem>
                              <StartAppNavItem
                                pageNumber={
                                  FORM_ID.CUSTOMER_COMPLAINT_DISCLOSURE
                                }
                                isCurrentPage={
                                  props.currentForm ===
                                  FORM_ID.CUSTOMER_COMPLAINT_DISCLOSURE
                                }
                                isPageComplete={
                                  props?.custCompDisclosureCompleteInd?.ind
                                }
                                navName={
                                  FORM_NAMES.CUSTOMER_COMPLAINT_DISCLOSURE
                                }
                                currentStep={
                                  props?.custCompDisclosureCompleteInd?.step
                                }
                              ></StartAppNavItem>
                              <StartAppNavItem
                                pageNumber={FORM_ID.TERMINATION_DISCLOSURE}
                                isCurrentPage={
                                  props.currentForm ===
                                  FORM_ID.TERMINATION_DISCLOSURE
                                }
                                isPageComplete={
                                  props?.termDisclosureCompleteInd?.ind
                                }
                                navName={FORM_NAMES.TERMINATION_DISCLOSURE}
                                currentStep={
                                  props?.termDisclosureCompleteInd?.step
                                }
                              ></StartAppNavItem>
                              <StartAppNavItem
                                pageNumber={FORM_ID.FINANCIAL_DISCLOSURE}
                                isCurrentPage={
                                  props.currentForm ===
                                  FORM_ID.FINANCIAL_DISCLOSURE
                                }
                                isPageComplete={
                                  props?.finDisclosureCompleteInd?.ind
                                }
                                navName={FORM_NAMES.FINANCIAL_DISCLOSURE}
                                currentStep={
                                  props?.finDisclosureCompleteInd?.step
                                }
                              ></StartAppNavItem>
                              <hr />
                            </Collapse.Collapse>
                          </Collapse.Group>
                        </Collapse>
                      </>
                    )}
                  {(props.contracttypedesc ===
                    CONTRACT_TYPE_DESCRIPTIONS.BROKER_CORP ||
                    props.contracttypedesc ===
                      CONTRACT_TYPE_DESCRIPTIONS.MEMBER_CORP ||
                    props.contracttypedesc ===
                      CONTRACT_TYPE_DESCRIPTIONS.INDIVIDUAL_BROKER) && (
                    <StartAppNavItem
                      pageNumber={FORM_ID.BROKER_DEALER}
                      isCurrentPage={
                        props.currentForm === FORM_ID.BROKER_DEALER
                      }
                      isPageComplete={props.brokerCompleteInd}
                      navName={FORM_NAMES.BROKER_DEALER}
                    ></StartAppNavItem>
                  )}
                  {(props.contracttypedesc ===
                    CONTRACT_TYPE_DESCRIPTIONS.BROKER_CORP ||
                    props.contracttypedesc ===
                      CONTRACT_TYPE_DESCRIPTIONS.MEMBER_CORP ||
                    props.contracttypedesc ===
                      CONTRACT_TYPE_DESCRIPTIONS.INDIVIDUAL_BROKER) && (
                    <StartAppNavItem
                      pageNumber={FORM_ID.CCB}
                      isCurrentPage={props.currentForm === FORM_ID.CCB}
                      isPageComplete={props.ccbCompleteInd}
                      navName={FORM_NAMES.CCB}
                    ></StartAppNavItem>
                  )}
                  {(props.contracttypedesc ===
                    CONTRACT_TYPE_DESCRIPTIONS.BROKER_CORP ||
                    props.contracttypedesc ===
                      CONTRACT_TYPE_DESCRIPTIONS.MEMBER_CORP ||
                    props.contracttypedesc ===
                      CONTRACT_TYPE_DESCRIPTIONS.INDIVIDUAL_BROKER) && (
                    <StartAppNavItem
                      pageNumber={FORM_ID.ERRORS_OMISSIONS}
                      isCurrentPage={
                        props.currentForm === FORM_ID.ERRORS_OMISSIONS
                      }
                      isPageComplete={props.EOCompleteInd}
                      navName={FORM_NAMES.ERRORS_OMISSIONS}
                    ></StartAppNavItem>
                  )}
                  {props.contracttypedesc !==
                    CONTRACT_TYPE_DESCRIPTIONS.FINANCING_ONLY &&
                    props.contracttypedesc !==
                      CONTRACT_TYPE_DESCRIPTIONS.MMLIS &&
                    props.contracttypedesc !==
                      CONTRACT_TYPE_DESCRIPTIONS.MEMBER_CORP &&
                    props.contracttypedesc !==
                      CONTRACT_TYPE_DESCRIPTIONS.BROKER_CORP &&
                    props.contracttypedesc !==
                      CONTRACT_TYPE_DESCRIPTIONS.PRELIMINARY &&
                    props.contracttypedesc !==
                      CONTRACT_TYPE_DESCRIPTIONS.CRIA_ONLY &&
                    props.contracttypedesc !==
                      CONTRACT_TYPE_DESCRIPTIONS.INVESTMENT_ADVISOR && (
                      <StartAppNavItem
                        pageNumber={FORM_ID.DIRECT_DEPOSIT}
                        isCurrentPage={
                          props.currentForm === FORM_ID.DIRECT_DEPOSIT
                        }
                        isPageComplete={props.directDepositCompleteInd}
                        navName={FORM_NAMES.DIRECT_DEPOSIT}
                      ></StartAppNavItem>
                    )}
                  {(props.isMMLIS ||
                    props.contracttypedesc ===
                      CONTRACT_TYPE_DESCRIPTIONS.MMLIS) && (
                    <StartAppNavItem
                      pageNumber={FORM_ID.MMLIS_INTRO}
                      isCurrentPage={
                        props.currentForm === FORM_ID.MMLIS_INTRO ||
                        props.currentForm === FORM_ID.MMLIS_PAY_TO_PLAY_1 ||
                        props.currentForm === FORM_ID.MMLIS_PAY_TO_PLAY_2 ||
                        props.currentForm === FORM_ID.MMLIS_OBA_CRIA
                      }
                      isPageComplete={
                        props?.mmlisPage1CompleteInd &&
                        props?.mmlisPage2CompleteInd &&
                        props?.mmlisOBACRIACompleteInd
                      }
                      navName={FORM_NAMES.MMLIS}
                      currentStep={mmlisPageStep}
                    ></StartAppNavItem>
                  )}
                </Collapse.Collapse>
              </Collapse.Group>
            </Collapse>
          </div>
          <div className="col-12 upload-doc-btn-wrapper">
            <div>
              <button
                id="uploadDocBtn"
                className="btn btn-link"
                onClick={handleShowUploadDocModal}
                disabled={!props?.hasSSN}
              >
                <strong>Upload Documentation</strong>
              </button>
            </div>
          </div>
          <div className="row review-sign-wrapper">
            <div className="col-12">
              <div>
                <Button
                  id="reviewAndSignBtn"
                  variant={disableReviewSignBtn ? "primary" : "secondary"}
                  disabled={disableReviewSignBtn}
                  onClick={() => props.toggleForm(FORM_ID.REVIEW_SIGN_1)}
                >
                  Review & Sign
                </Button>
              </div>
            </div>
          </div>
          {!ReviewSignForms.includes(props.currentForm) && (
            <div className="row mobile-review-sign-wrapper">
              <div className="col-12">
                <div>
                  <Button
                    id="reviewAndSignBtn"
                    variant={disableReviewSignBtn ? "primary" : "secondary"}
                    disabled={disableReviewSignBtn}
                    onClick={() => props.toggleForm(FORM_ID.REVIEW_SIGN_1)}
                  >
                    Review & Sign
                  </Button>
                </div>
              </div>
            </div>
          )}

          <div className="col-12 btn-link-wrapper">
            <div>
              <button
                id="exitBtn"
                className="btn btn-link"
                onClick={handleShowModal}
              >
                <strong>Exit</strong>
              </button>
            </div>
          </div>
        </>
      )}

      {showUploadModal ? (
        <UploadDocument
          docReqUploadModalData={docReqUploadModalData}
          oktaSubId={props?.oktasubid}
          contractid={props?.contractid}
          contracttype={props?.contracttypedesc}
          isRequested={reqDocs?.length > 0}
          isDocReqUploadModalOpen={showUploadModal}
          onDocumentsUploaded={() => setRefetchDocStatus(true)}
          setIsDocReqUploadModalOpen={setShowUploadModal}
          onShowConfirmationModal={() => setShowConfirmationModal(true)}
        />
      ) : null}

      <DocConfirmationModal
        isOpen={showConfirmationModal}
        onClose={handleCloseConfirmationModal}
      />
      <LostDataModal
        isOpen={showModal}
        handleClose={handleModalClose}
        handleProceed={handleExitClick}
      />
    </div>
  );
};

export default StartApplicationNav;
